import { useState } from 'react';
import { format } from 'date-fns';
import { BASE_URL } from '../../services/api';
import { Modal, ModalGateway } from 'react-images';

export default function GalleryCard({ data }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isLightboxOpen, setIsLightboxOpen] = useState(false);

    const media = [
        ...(data.videoLink
            ? [
                  {
                      src: `https://img.youtube.com/vi/${data.videoLink.split('v=')[1]}/hqdefault.jpg`,
                      type: 'video',
                      videoUrl: data.videoLink,
                      width: 16,
                      height: 9,
                  },
              ]
            : []),
        ...data.photoUrls.map((photoUrl) => ({
            src: `${BASE_URL}${photoUrl}`,
            type: 'photo',
            width: 4,
            height: 3,
        })),
    ];

    //console.log(data)

    // Open lightbox
    const openLightbox = (event, { index }) => {
        setCurrentIndex(index);
        setIsLightboxOpen(true);
    };

    // Close lightbox
    const closeLightbox = () => {
        setIsLightboxOpen(false);
    };

    const getVideoEmbedUrl = (url) => {
        const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?youtu(?:\.be\/|be\.com\/(?:watch\?v=|embed\/|v\/|.+\?v=))([^&\n?#]+)/;
        const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)/;
        const videoFileRegex = /\.(mp4|webm|ogg)(\?.*)?$/;
    
        if (youtubeRegex.test(url)) {
            const videoId = url.match(youtubeRegex)[1];
            return { type: 'youtube', url: `https://www.youtube.com/embed/${videoId}` };
        } else if (vimeoRegex.test(url)) {
            const videoId = url.match(vimeoRegex)[1];
            return { type: 'vimeo', url: `https://player.vimeo.com/video/${videoId}` };
        } else if (videoFileRegex.test(url)) {
            return { type: 'file', url };
        } else {
            return { type: 'invalid', url: '' };
        }
    };

    return (
        <>
            {/* Main Gallery Card */}
            <div
                className="relative aspect-[16/9] w-full rounded-lg overflow-hidden shadow-lg mb-4 cursor-pointer"
                onClick={() => openLightbox(null, { index: 0 })}
            >
                <div className="relative h-full overflow-hidden">
                    {data.videoLink ? (
                        <div className="relative w-full h-0 pb-[56.25%]">
                            <iframe
                                src={getVideoEmbedUrl(data.videoLink)?.url}
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                className="absolute top-0 left-0 w-full h-full rounded-lg"
                            ></iframe>
                        </div>
                    ) : (
                        <img
                            src={`${BASE_URL}${data.photoUrls[0]}`}
                            alt="Artikel"
                            className="w-full h-full object-cover"
                        />
                    )}
                </div>
                <div className="absolute inset-0 top-auto h-16 bg-black opacity-40"></div>
                <div className="absolute top-[18%] left-0 text-white text-sm mb-12 flex flex-row">
                    <div className="bg-white text-[#00453F] px-3 py-2">
                        {format(new Date(data.createdAt), 'ii')}
                    </div>
                    <div className="bg-[#00453F] px-3 py-2">
                        {format(new Date(data.createdAt), 'LLL yyyy')}
                    </div>
                </div>
                <div className="absolute left-0 top-[70%] px-6">
                    <p className="p-1 text-xs bg-[#00453F] font-semibold text-white mb-2">{data.title}</p>
                </div>
            </div>

            {/* Lightbox */}
            <ModalGateway>
                {isLightboxOpen && (
                    <Modal onClose={closeLightbox}>
                        {media[currentIndex].type === 'video' ? (
                            <div className="video-container flex items-center justify-center max-w-full max-h-full mx-auto rounded-lg">
                                <iframe
                                    src={getVideoEmbedUrl(media[currentIndex]?.videoUrl)?.url}
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    className="rounded-lg"
                                ></iframe>
                            </div>
                        ) : (
                            <img
                                src={media[currentIndex].src}
                                alt="Media"
                                className="max-w-full max-h-full mx-auto rounded-lg"
                            />
                        )}
                    </Modal>
                )}
            </ModalGateway>
        </>
    );
}
